module.exports = __webpack_public_path__ + "img/s2P39.68706329.png";